var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-rules" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `paddingTop:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.goBack },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow05.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "tit-left" }, [
                    _vm._v(_vm._s(_vm.$t("lang.call.tit1")) + "123"),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("div", { staticClass: "main right-read" }, [
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.commonM.k320"))),
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.commonM.k321"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k322"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k323"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k324"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("4. " + _vm._s(_vm.$t("lang.commonM.k325"))),
      ]),
      _c("br"),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.commonM.k326"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k327"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k328"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k329"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("4. " + _vm._s(_vm.$t("lang.commonM.k330"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("5. " + _vm._s(_vm.$t("lang.commonM.k331"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v("6. " + _vm._s(_vm.$t("lang.commonM.k332"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }